import React from "react";
import type {ColGroupDef, ICellRendererParams} from "ag-grid-community";
import type {ExcessGroupMatrixRecord} from "../../../../api/types/excessGroup";
import {SelectElementModelFE} from "../../../../api/types/generic";
import {ExcessGroupDetail} from "../../../../api/types/excessGroupDetail";
import {i18nConvertNumberWithDecimals} from "../../../../utils";
import {maxNumberYupLimit} from "../../../../constants";


const cellValueSetter = (params: any) => {
    console.log(params)
    if (params?.newValue !== null && params?.newValue !== undefined) {
        params.newValue = (params.newValue + '').replace(/,/g, '.');
    }
    if (!Number(params.newValue) && params.newValue != 0) {
        return false;
    } else if (params.newValue <= maxNumberYupLimit && params.newValue >= 0) {
        params.data[params.colDef.field.split(".")[0]] = {
            ...params.data[params.colDef.field.split(".")[0]],
            amount: Number(params.newValue)
        };
        return true;
    } else return false;
};

export const useMatrixColDefs = ({
                                     matrixData,
                                     excesses,
                                     editable,
                                     t
                                 }: {
    matrixData: ExcessGroupDetail[];
    excesses: SelectElementModelFE[];
    editable: boolean;
    t: Function
}): ColGroupDef<ExcessGroupMatrixRecord>[] => {
    const excessColumns: ExcessGroupDetail[] = [];

    matrixData.forEach(detail => {
        if (!excessColumns.find(e => e.id.excessId === detail.id.excessId)) {
            excessColumns.push(detail);
        }
    });

    return [
        {
            headerName: "",
            children: [
                {
                    headerName: t("pricing:excessGroup.table.headers.carGroup"),
                    headerTooltip: t("pricing:excessGroup.table.headers.carGroup"),
                    field: "carGroup",
                    width: 240,
                    editable: false,
                    pinned: "left"
                }
            ]
        },
        {
            headerName: t("pricing:excessGroup.table.headers.excesses"),
            headerClass: ["bordersRight"],
            children:
                excessColumns.map((detail) => {
                    const excess = excesses.find((excess) => excess.code === detail?.id.excessId);
                    return excess ? {
                        headerName: excess?.label,
                        headerClass: ["bordersRight"],
                        field: `${excess.label}.amount`,
                        width: excessColumns?.length > 6 ? 100 : undefined,
                        flex: excessColumns?.length > 6 ? undefined : 1,
                        cellEditor: "customEditor",
                        valueSetter: cellValueSetter,
                        cellRenderer: (params: ICellRendererParams) => i18nConvertNumberWithDecimals(params.value),
                        cellStyle: {
                            justifyContent: "flex-end",
                            textAlign: "right",
                            padding: 5,
                            borderRight: "2px solid #E0E0E0"
                        },
                        editable
                    } : {};
                })
        },
        {
            headerName: "",
            children: [
                {
                    field: "excessGroupId",
                    hide: true
                }
            ]
        }
    ];
};

